"use client";

import { useUserLists } from "@/components/UserListsProvider";
import type { Product } from "@/lib/catalog";

function HeartIcon({ active }: { active: boolean }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 20.2 4.9 13.4a4.9 4.9 0 0 1 6.9-7l.2.2.2-.2a4.9 4.9 0 0 1 6.9 7Z"
        fill={active ? "currentColor" : "none"}
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
    </svg>
  );
}

type ProductFavoriteButtonProps = {
  product: Product;
  variant?: "icon" | "inline";
  className?: string;
};

export function ProductFavoriteButton({
  product,
  variant = "icon",
  className
}: ProductFavoriteButtonProps) {
  const { isFavorite, toggleFavorite, isAuthenticated } = useUserLists();
  const active = isFavorite(product.slug);
  const buttonLabel = active ? "Убрать из избранного" : "Добавить в избранное";

  return (
    <button
      type="button"
      aria-label={buttonLabel}
      aria-pressed={active}
      className={`saved-toggle saved-toggle--${variant} ${active ? "is-active" : ""} ${className ?? ""}`.trim()}
      onClick={async (event) => {
        event.preventDefault();
        event.stopPropagation();

        const result = await toggleFavorite(product);
        if (result.authRequired && typeof window !== "undefined") {
          const next = `${window.location.pathname}${window.location.search}`;
          window.location.href = `/account/login?next=${encodeURIComponent(next)}`;
        }
      }}
      title={!isAuthenticated ? "Добавление в избранное доступно после входа" : buttonLabel}
    >
      <HeartIcon active={active} />
      {variant === "inline" ? <span>{active ? "В избранном" : "В избранное"}</span> : null}
    </button>
  );
}
